// @wangeditor/editor-for-vue 的静态 import 在 Node 中会抛 Element is not defined,
// 所以不能在服务端加载。同时 Vue 2 的 <client-only> 在服务端渲染时仍会先创建
// 槽内容 vnode、触发异步组件工厂,因此工厂本身也必须对服务端安全:
// - 客户端:动态 import 真组件(懒加载 chunk)
// - 服务端:返回渲染空占位的功能组件,SSR 输出为空,客户端挂载后再渲染真组件
export function lazyWangeditor(key) {
  return () => {
    if (process.client) {
      return import("@wangeditor/editor-for-vue").then((m) => m[key]);
    }
    return Promise.resolve({
      name: "ServerEditorPlaceholder",
      functional: true,
      render: (h) => h(false),
    });
  };
}
